import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSetQueryParams } from '../../../utils/urls/appQueryParamUtilsLegacy';
import { AvailableUseCases, useCasesQueryParamKey } from './useCaseConstants';
import { getValidUniqueUseCasesParams } from './useCaseUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const UseCaseContext = /*#__PURE__*/createContext(null);
export const UseCaseProvider = ({
  children
}) => {
  const history = useHistory();
  const setQueryParams = useSetQueryParams();
  const initialStateRef = useRef(getValidUniqueUseCasesParams(history.location.search, AvailableUseCases));
  const [selectedUseCases, setSelectedUseCases] = useState(initialStateRef.current.useCases);
  useEffect(() => {
    if (initialStateRef.current.wasModified) {
      setQueryParams({
        [useCasesQueryParamKey]: initialStateRef.current.useCases
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const toggleUseCase = useCallback(useCase => {
    setSelectedUseCases(prev => {
      const newSelection = prev.includes(useCase) ? prev.filter(uc => uc !== useCase) : [...prev, useCase];
      if (newSelection.length === 0) {
        return prev;
      }
      setQueryParams({
        [useCasesQueryParamKey]: newSelection
      });
      return newSelection;
    });
  }, [setQueryParams]);
  const contextValue = useMemo(() => ({
    selectedUseCases,
    toggleUseCase
  }), [selectedUseCases, toggleUseCase]);
  return /*#__PURE__*/_jsx(UseCaseContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useUseCaseContext = () => {
  const context = useContext(UseCaseContext);
  if (!context) {
    throw new Error('useUseCaseContext must be used within UseCaseProvider');
  }
  return context;
};